export { default as SquaredTabs } from "./SquaredTabs";
